
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    mobileFilterBarWrapper: {
        display: 'none',
        '@media only screen and (min-width : 360px) and (max-width : 736px)': {
            display: 'block'
        }
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/SearchContent/styles.js